import { Component } from '@angular/core';

@Component({
    selector: 'lib-inactive-feature',
    templateUrl: './inactive-feature.component.html',
    styleUrls: ['./inactive-feature.component.scss'],
    standalone: false
})
export class InactiveFeatureComponent {

}
